/* istanbul ignore next */ // https://cianru.atlassian.net/browse/CD-50840
import { EMapTypes } from '../../constants/map';
import { getMapInfrastructure } from '../../services/getInfrastructure';
import {
  TInfrastructureBbox,
  EInfrastructureCategory,
  TIOSMInfrastructure,
  TIOSMInfrastructureResponse,
} from '../../types';
import { IThunkActionCreator } from '../../types/store';

export enum InfrastructureType {
  Schools,
  Kindergarden,
  Polyclinics,
  GroceryStores,
  Cafes,
  Mixed,
}

export interface IMapState {
  infrastructureList: TIOSMInfrastructure[];
  yandexApiKeySatellite?: string | null;
  mapType: EMapTypes;
}

export const InfrastructureCategory: Record<
  Exclude<InfrastructureType, InfrastructureType.Mixed>,
  EInfrastructureCategory
> = {
  [InfrastructureType.Schools]: EInfrastructureCategory.School,
  [InfrastructureType.Kindergarden]: EInfrastructureCategory.Nursery,
  [InfrastructureType.Polyclinics]: EInfrastructureCategory.Clinic,
  [InfrastructureType.GroceryStores]: EInfrastructureCategory.Grocery,
  [InfrastructureType.Cafes]: EInfrastructureCategory.Cafe,
};

export function searchMapInfrastructure(bbox: TInfrastructureBbox): IThunkActionCreator {
  return (dispatch, _, context) => {
    getMapInfrastructure(context, bbox).then((response: TIOSMInfrastructureResponse) => {
      dispatch<ISetInfrastructureListAction>({
        infrastructureList: response.infrastructure,
        type: 'ISetInfrastructureListAction',
      });
    });
  };
}

export function setMapType(mapType: EMapTypes) {
  return {
    type: 'ISetMapTypeAction',
    mapType,
  };
}

export interface ISetInfrastructureListAction {
  type: 'ISetInfrastructureListAction';
  infrastructureList: TIOSMInfrastructure[];
}

// https://cianru.atlassian.net/browse/CD-50840
/* istanbul ignore next */
export interface ISetMapTypeAction {
  type: 'ISetMapTypeAction';
  mapType: EMapTypes;
}

const defaultState: IMapState = {
  infrastructureList: [],
  mapType: EMapTypes.satellite,
};

type TMapActions = ISetMapTypeAction | ISetInfrastructureListAction;

export function mapReducer(state: IMapState = defaultState, action: TMapActions): IMapState {
  switch (action.type) {
    case 'ISetInfrastructureListAction':
      return {
        ...state,
        infrastructureList: action.infrastructureList,
      };
    case 'ISetMapTypeAction':
      return {
        ...state,
        mapType: action.mapType,
      };
    default:
      return state;
  }
}
